import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  useTheme,
} from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import PlaylistAddCheckRoundedIcon from "@material-ui/icons/PlaylistAddCheckRounded";
import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { FiDownload, FiEdit2, FiFileText, FiLogIn, FiShare2, FiTrash2 } from "react-icons/fi";
import { LuArrowDown, LuArrowDownUp, LuArrowUp, LuInbox } from "react-icons/lu";
import { useHistory, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import SearchBar from "../../../common/Search";
import { isGuideDone, readGuideProgress, saveGuideProgress } from "../../../common/guides";
import CustomTabs from "../../../common/Tabs";
import CustomTooltip from "../../../common/Tooltip";
import AisMap from "../../../components/Calculator/AddCalculatorFleet/AisMap";
import AutoAddFleet from "../../../components/Calculator/AddCalculatorFleet/AutoAddFleet";
import VesselContractForm from "../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import LiveVesselLocation from "../../../components/Calculator/AddCalculatorFleet/liveVesselLocation";
import ManualAddFleet from "../../../components/Calculator/AddCalculatorFleet/ManualAddFleet";
import UserCopyFleet from "../../../components/Calculator/AddCalculatorFleet/UserCopyFleet";
import SaveCargoLabel from "../../../components/Calculator/SaveCargoLabel";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomButton from "../../../components/Common/CustomButton";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import AddNewVessel, { VesselAIModal } from "../../../components/Dashboard/AddNewVessel";
import {
  initialAddFleet,
  initialVesselState,
} from "../../../constants";
import {
  getCurrentUserId,
  getCurrentUserOrganizationId,
  getOrganizationId,
  toastError,
  toastSuccess,
} from "../../../utils";
import * as actions from "../Calculator/actions";
import * as dashboardActions from "../Dashboard/actions";
import { exportVesselPdf } from "./vesselRowPdf";
import { usePdfShare } from "../../../util/pdfFile";
import SingleVessel from "../Dashboard/Vessel";
import EditVesselOnFleetAdd from "../Dashboard/Vessel/editVesselOnFleetAdd";
import EditVesselOnFleetAddStep from "../Dashboard/Vessel/steps/editVesselOnFleetAddStep";
import { createVesselContract, getTrackedVessel } from "./action";

const initialSearchType = {
  type: "",
  saveLabel: "",
  name: "",
  firstLoadPort: "",
  lastDischargePort: "",
  loadQuantity: "",
  createdDate: "",
};

const initialVesselContractFormData = {
  contractName: '',
  vesselId: '',
  vesselFixtureId: '',
  cpDate: moment().format('YYYY-MM-DD'),
  counterParty: '',
  bankingDetails: '',
  contractingCompany: '',
  department: '',
  tradeArea: '',
  vesselType: '',
  currency: '',
  shipmentNo: '',
  charteringPIC: '',
  opsCoordinator: '',
  comments: '',
  vesselDetails: {}
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="pt-1">
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

const menuItemStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: 12,
  minHeight: 32,
  color: "#374151",
  padding: "5px 12px",
};

const useStyles = makeStyles({
  darkerUnchecked: {
    color: "#cccccc",
  },
});

function MyVessel(props) {
  const { prepareShare, shareDialog } = usePdfShare();
  const {
    loader = false,
    setLoader = () => { },
    setSearchValue = () => { },
    searchValue,
    DatefilterValue,
  } = props;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState();
  const openMenu = Boolean(anchorEl);

  const handleMenuOpen = (event, item) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const thStyle = {
    padding: "5px 6px",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: "0.02em",
    color: "#334155",
    textTransform: "capitalize",
    textAlign: "left",
    borderBottom: "1px solid #cbd5e1",
    whiteSpace: "nowrap",
    background: "#e2e8f0",
  };

  const tdStyle = {
    padding: "0.5px 6px",
    fontSize: 11,
    color: "#1e293b",
    borderBottom: "1px solid #e2e8f0",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  };

  const iconBtnStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    borderRadius: 4,
    border: "none",
    background: "transparent",
    color: "#334155",
    cursor: "pointer",
    transition: "background 0.15s, color 0.15s",
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  // Initialize value from URL (following Contracts pattern)
  const [value, setValue] = useState(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    if (tabParam === "addVessel" || tabParam === "6" || tabParam === "add-vessel") {
      return 6;
    }
    return 0;
  });
  const [extraTabsValue, setExtraTabsValue] = useState(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    const subTabParam = searchParams.get("subTab");
    if ((tabParam === "addVessel" || tabParam === "6" || tabParam === "add-vessel") && subTabParam) {
      return parseInt(subTabParam, 10);
    }
    return 1;
  });
  const [fleets, setFleets] = useState([]);
  const [searchType, setSearchType] = useState({ ...initialSearchType });
  const [addFleetModal, setAddFleetModal] = useState(false);
  const [vesselCreationMode, setVesselCreationMode] = useState(false);
  const [addFleetsArray, setAddFleetsArray] = useState([
    { ...initialAddFleet },
  ]);
  const [myFilters, setMyFilters] = useState({
    offset: 1,
    limit: 50,
    sortBy: "createdDate",
    sortDirection: "desc",
  });

  const [aisPage, setAisPage] = useState(1);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState({});
  const [hasFetchedFleets, setHasFetchedFleets] = useState(false);

  useEffect(() => {
    window.redirectToVesselListTab = () => {
      setValue(0);
      history.replace({ search: "?tab=vesselList" });
    };
    return () => {
      delete window.redirectToVesselListTab;
    };
  }, []);

  useEffect(() => {
    const progress = readGuideProgress("vessel_tab");
    if (!isGuideDone("vessel") && !progress.dismissed && progress.currentStepIndex > 0 && progress.currentStepIndex < 7) {
      setValue(6);
      setShowExtraTabs(true);
    }
  }, []);

  // Sync tab state from URL (same pattern as Contracts/index.js)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    const subTabParam = searchParams.get("subTab");
    if (tabParam === "addVessel" || tabParam === "6" || tabParam === "add-vessel") {
      setValue(6);
      setShowExtraTabs(true);
      // Set sub-tab from URL (1=Manual, 2=Auto, 3=Users, 4=AIS, 5=Markets)
      const subTabValue = subTabParam ? parseInt(subTabParam, 10) : 1;
      setExtraTabsValue(subTabValue);
      if (subTabValue === 2) {
        onSubmitAutoSearch();
      }
    } else if (tabParam === "vesselList" || tabParam === "0" || tabParam === "myVessel") {
      setValue(0);
      setShowExtraTabs(false);
    } else if (!tabParam) {
      // No tab param - set default URL (like Contracts does with history.replace)
      history.replace({ search: "?tab=vesselList" });
    }
  }, [location.search]);
  //tabs
  const [vesselLoading, setVesselLoading] = useState({});
  const [portLoading, setPortLoading] = useState({});
  const [saveVesselListByIndex, setSaveVesselListByIndex] = useState({});
  const [savePortListByIndex, setSavePortListByIndex] = useState({});
  const [newVesselSavePortList, setNewVesselSavePortList] = useState([]);
  const [newVesselPortLoading, setNewVesselPortLoading] = useState(false);
  const editVesselRef = useRef(null);
  const [autoSwitch, setAutoSwitch] = useState(false);
  const [emailFleetList, setEmailFleetList] = useState([]);
  const [autoFilters, setAutoFilters] = useState({
    updateSince: { label: "1", value: "1" },
    portRegion: [
      // { label: "Unknown", value: "Unknown" }
    ],
    vesselType: { label: "All", value: "0_99999999" },
    gear: { label: "All", value: "All" },
  });
  const [showExtraTabs, setShowExtraTabs] = useState(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    return tabParam === "addVessel" || tabParam === "6" || tabParam === "add-vessel";
  });
  const [selectedAutoFleet, setSelectedAutoFleet] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [onValidationVessel, setValidationVessel] = useState(false);
  const [IsDisplayLiveLocationOfVessels, setIsDisplayLiveLocationOfVessels] =
    useState(false);
  const [onValidationVesselFromAuto, setValidationVesselFromAuto] =
    useState(false);
  const [onValidationVesselIndex, setValidationVesselIndex] = useState(0);
  const [onValidationVesselFromAutoIndex, setValidationVesselFromAutoIndex] =
    useState("");
  const [addFleetRegionOptions, setAddFleetRegionOptions] = useState([]);
  const [vesselManager, setVesselManager] = useState([]);
  const [singleResults, setSingleResults] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [isShareConfirm, setShareConfirm] = useState(false);
  const [getSingleVesselData, setSingleVesselData] = useState("");
  const [shareLabel, setShareLabel] = useState("");
  const [shareLabelError, setShareLabelError] = useState(false);
  const [newVessel, setNewVessel] = useState({ ...initialVesselState });
  const [aiOpen, setAiOpen] = useState(false);
  const [selectedVesssel, setSelectedVesssel] = useState(null);
  const [saveVesselVesselLabel, setSaveVesselVesselLabel] = useState("");
  const [vesselVesselModal, setVesselVesselModal] = useState(false);
  const organizationId = getCurrentUserOrganizationId();
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [socket, setSocket] = useState(null);
  const [receivedMMSI, setReceivedMMSI] = useState([]);
  const [
    isDisplaySelectedRegionDataTable,
    setIsDisplaySelectedRegionDataTable,
  ] = useState(false);
  const [subLoader, setSubLoader] = useState(false);
  const [selectedVesselType, setSelectedVesselType] = useState("all");
  const [isVesselContractFormOpen, setIsVesselContractFormOpen] = useState(false);

  const [filtersForAis, setFiltersForAis] = useState({
    search: "",
    startDate: null,
    endDate: null,
  });
  const [formatedCoordinates, setFormatedCoordinates] = useState([]);
  const [formData, setFormData] = useState(initialVesselContractFormData);
  const [textContract, setTextContract] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const hasTriggeredVerificationStepRef = useRef(false);

  const onDateFilter = () => {
    setFleets(DatefilterValue);
  };
  useEffect(() => {
    onDateFilter();
  }, [DatefilterValue]);

  const onSearchVessel = (search) => {
    getAllFleets(false, { search: search });
  };
  const delaySearch = useCallback(
    _.debounce((data) => onSearchVessel(data), 500),
    []
  );
  const handleSearchAisTab = (data) => {
    const payload = {
      search: data,
      startDate: filtersForAis.startDate,
      endDate: filtersForAis.endDate,
    };
    handleAisFilters(payload);
  };
  const delaySearchForAis = useCallback(
    _.debounce((data) => handleSearchAisTab(data), 100),
    [filtersForAis]
  );

  const onSearchChange = (e) => {
    setFiltersForAis({
      search: e.target.value,
      startDate: filtersForAis.startDate,
      endDate: filtersForAis.endDate,
    });
    delaySearchForAis(e.target.value);
  };

  const isFirstRenderSearch = useRef(true);
  useEffect(() => {
    if (isFirstRenderSearch.current) {
      isFirstRenderSearch.current = false;
      return;
    }
    delaySearch(searchValue);
  }, [searchValue, delaySearch]);

  const handleDateRangeChange = async (newDateRange) => {
    const { startDate, endDate } = newDateRange;
    // Ensure dates are in ISO string format
    const formattedStartDate = startDate?.toISOString() || "";
    const formattedEndDate = endDate?.toISOString() || "";
    setFiltersForAis({
      search: filtersForAis.search,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    });
    handleAisFilters({
      search: filtersForAis.search,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    });
  };
  useEffect(() => {
    getVesselManager();
    getAllFleets();
  }, []);
  const getVesselManager = async () => {
    await actions
      .getVesselManagerData()
      .then((res) => {
        setVesselManager(res?.data?.allVesselManager);
      })
      .catch(() => { });
  };
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const getDwtValue = (item) => {
    const parsed = (() => {
      try {
        return typeof item?.vessel === "string" ? JSON.parse(item?.vessel || "{}") : (item?.vessel || {});
      } catch (e) {
        return {};
      }
    })();
    return Number(item?.dwt || parsed?.vesselDwt || parsed?.dwt || parsed?.DWT || 0);
  };

  const getVesselNameValue = (item) => {
    const parsed = (() => {
      try {
        return typeof item?.vessel === "string" ? JSON.parse(item?.vessel || "{}") : (item?.vessel || {});
      } catch (e) {
        return {};
      }
    })();
    return (parsed?.vesselName || item?.vesselName || "").toLowerCase();
  };

  const getAllFleets = async (fromCheck = false, fromPagination) => {
    if (!hasFetchedFleets && (!fleets || fleets.length === 0)) {
      setIsInitialLoading(true);
      setLoader(true);
    }

    await actions
      .userFleets(
        fromPagination
          ? { ...fromPagination, isPending: false }
          : { ...myFilters, isPending: false }
      )
      .then((res) => {
        setIsInitialLoading(false);
        setLoader(false);
        setHasFetchedFleets(true);
        let list = (res.data && Array.isArray(res.data.list) && res.data.list) || [];
        const activeSortBy = fromPagination?.sortBy || myFilters.sortBy;
        const activeSortDirection = fromPagination?.sortDirection || myFilters.sortDirection;

        if (activeSortBy === "dwt" && list.length) {
          const dir = activeSortDirection === "asc" ? 1 : -1;
          list = [...list].sort((a, b) => (getDwtValue(a) - getDwtValue(b)) * dir);
        } else if (activeSortBy === "vesselName" && list.length) {
          const dir = activeSortDirection === "asc" ? 1 : -1;
          list = [...list].sort((a, b) => getVesselNameValue(a).localeCompare(getVesselNameValue(b)) * dir);
        }

        setFleets(list);
        if (!hasFetchedFleets) {
          window.handleVesselTourAction?.(list.length ? "vessel_existing" : "no_vessels");
        }
        setMyFilters((prev) => ({
          ...prev,
          ...fromPagination,
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage,
        }));
      })
      .catch(() => {
        setIsInitialLoading(false);
        setLoader(false);
        setHasFetchedFleets(true);
        toastError();
      });
  };

  const onClickEditVessel = async (item) => {
    await actions
      .getSingleFleetData(item?._id, { userId: getCurrentUserId() })
      .then((res) => {
        setSingleResults(
          { ...res?.data, vesseldata: JSON.parse(res?.data?.vessel) } || {}
        );
        setIsEdit(true);
        setOpen(true);
      })
      .catch((err) => {
        toastError(err?.data?.message);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchType({ ...initialSearchType });
    // Push URL change (same pattern as Contracts handleSubTabChange)
    if (newValue === 6) {
      history.push({ search: "?tab=addVessel&subTab=1" });
    } else if (newValue === 0) {
      history.push({ search: "?tab=vesselList" });
    }
    if (newValue === 2) {
      onSubmitAutoSearch();
    }
  };

  const handleChangeExtraTabs = (event, newValue) => {
    setExtraTabsValue(newValue);
    setSearchType({ ...initialSearchType });
    // Sync URL with sub-tab change
    history.push({ search: `?tab=addVessel&subTab=${newValue}` });
    if (newValue === 2) {
      onSubmitAutoSearch();
    }
  };

  const onClickDeleteSavedFleet = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const onChangeMyPagination = (type = "") => {
    let newMyFilters = {};
    if (type === "inc") {
      newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
    } else if (type === "first") {
      newMyFilters = { ...myFilters, offset: 1 };
    } else {
      if (myFilters.offset === 1) return;
      newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
    }

    getAllFleets(false, { ...newMyFilters, search: searchValue });
  };

  const handleSortClick = (sortKey) => {
    let newSortDirection = "asc";
    if (myFilters.sortBy === sortKey) {
      if (myFilters.sortDirection === "asc") newSortDirection = "desc";
      else if (myFilters.sortDirection === "desc") {
        newSortDirection = sortKey === "createdDate" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdDate" ? "desc" : "asc";
    }

    let apiFilters = { ...myFilters, sortBy: sortKey, sortDirection: newSortDirection, offset: 1 };
    if (!newSortDirection) {
      apiFilters.sortBy = "createdDate";
      apiFilters.sortDirection = "desc";
    }

    getAllFleets(false, { ...apiFilters, search: searchValue });
  };

  const onDeleteFleet = () => {
    actions
      .deleteFleet(deleteId)
      .then((res) => {
        toastSuccess("Fleet deleted successfully");
        setDeleteModal(false);
        setDeleteId("");
        getAllFleets();
      })
      .catch((err) => {
        toastError();
      });
  };

  const onClickAddFleet = () => {
    setAddFleetModal((prev) => !prev);
  };
  //Tabs

  const delayVesselSearch = useCallback(
    _.debounce((index, search) => onSearchVesselList(index, search), 500),
    []
  );
  const delayPortSearch = useCallback(
    _.debounce((index, search) => onSearchPortList(index, search), 500),
    []
  );

  const delayNewVesselPortSearch = useCallback(
    _.debounce((search) => onSearchNewVesselPortList(search), 500),
    []
  );

  const onSearchNewVesselPortList = (value) => {
    if (value) {
      setNewVesselPortLoading(true);
      actions.portsByChar(value)
        .then((res) => {
          setNewVesselPortLoading(false);
          setNewVesselSavePortList(
            Array.isArray(res.data.list)
              ? res.data.list.map((item) => ({
                ...item,
                portLabel: `${item.name}${item.country ? ` (${item.country})` : ''}`
              }))
              : []
          );
        })
        .catch((err) => {
          setNewVesselPortLoading(false);
        });
    } else {
      setNewVesselPortLoading(false);
    }
  };

  useEffect(() => {
    // Only reset to vessel list if URL doesn't specify addVessel tab
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    if (!(tabParam === "addVessel" || tabParam === "6" || tabParam === "add-vessel")) {
      setValue(0);
    }
    actions.allPortRegions().then((res) => {
      const regionOptions =
        (Array.isArray(res?.data?.list) &&
          res?.data?.list?.map((region) => ({
            label: region,
            value: region,
          }))) ||
        [];
      setAddFleetRegionOptions([
        // { label: "Unknown", value: "Unknown" },
        ...regionOptions,
      ]);
    });
    return () => {
      setAddFleetsArray([{ ...initialAddFleet }]);
    };
  }, []);

  const onSearchVesselList = (index, value) => {
    if (value) {
      setVesselLoading((prev) => ({ ...prev, [index]: true }));
      actions
        .allVesselsByCharWithoutReducer(value)
        .then((res) => {
          setVesselLoading((prev) => ({ ...prev, [index]: false }));
          setSaveVesselListByIndex((prev) => ({
            ...prev,
            [index]:
              (Array.isArray(res.data.list) &&
                res.data.list.map((item) => ({
                  ...item,
                  vesselLabel: `${item.vesselName} ${item.vesselDwt}`,
                }))) ||
              [],
          }));
        })
        .catch((err) => {
          setVesselLoading((prev) => ({ ...prev, [index]: false }));
        });
    }
  };

  const onSearchPortList = (index, value) => {
    if (value) {
      setPortLoading((prev) => ({ ...prev, [index]: true }));
      actions
        .portsByChar(value)
        .then((res) => {
          setPortLoading((prev) => ({ ...prev, [index]: false }));
          setSavePortListByIndex((prev) => ({
            ...prev,
            [index]:
              (Array.isArray(res.data.list) &&
                res.data.list.map((item) => ({
                  ...item,
                  portLabel: `${item.name} ${item.country ? "(" + item.country + ")" : ""
                    }`,
                }))) ||
              [],
          }));
        })
        .catch((err) => {
          setPortLoading((prev) => ({ ...prev, [index]: false }));
        });
    } else {
      setPortLoading((prev) => ({ ...prev, [index]: false }));
    }
  };

  const onChangeNewFleetsValue = (index, name, value) => {
    let newAddFleetsArray = [...addFleetsArray];
    if (name === "vesselName") {
      newAddFleetsArray[index].vesselName = value.vesselName;
      newAddFleetsArray[index].selectedVessel = value;
    } else if (name === "port") {
      newAddFleetsArray[index].port = value.name;
      newAddFleetsArray[index].selectedPort = value;
      newAddFleetsArray[index].lat = value.lat || "";
      newAddFleetsArray[index].lng = value.lng || "";
    } else {
      newAddFleetsArray[index][name] = value;
    }
    newAddFleetsArray = newAddFleetsArray.map(obj => ({
      ...initialAddFleet,
      ...obj,
      selectedVessel: {
        ...initialAddFleet.selectedVessel,
        ...obj.selectedVessel,
      },
      selectedPort: {
        ...initialAddFleet.selectedPort,
        ...obj.selectedPort,
      },
    }));
    setAddFleetsArray(newAddFleetsArray);
  };

  const checkForRequired = () =>
    addFleetsArray.find(
      (item) => !item.vesselName || !item.port || !String(item.dateOpen)
    );

  const checkForRequiredFromAuto = (output) =>
    output?.find(
      (item) =>
        !item?.vesselName ||
        !item?.nearestport?.name ||
        !item?.nearestDate?.date
    );

  const onAddFleetLine = () => {
    if (!!checkForRequired()) return toastError("Please fill required fields");
    setAddFleetsArray([...addFleetsArray, { ...initialAddFleet }]);
  };

  const onDeleteVesselLine = (index) => {
    let newAddFleetsArray = [...addFleetsArray];
    newAddFleetsArray.splice(index, 1);
    setSaveVesselListByIndex({ ...saveVesselListByIndex, [index]: [] });
    setSavePortListByIndex({ ...savePortListByIndex, [index]: [] });
    setAddFleetsArray(newAddFleetsArray);
  };

  const removeExtraField = ({ selectedPort, selectedVessel, ...rest }) => ({
    ...rest,
  });

  const removeExtraFieldFromAuto = ({ nearestport, vesseldata, ...rest }) => ({
    ...rest,
  });

  const removeExtraFieldFromAutoVessel = ({ id, ...rest }) => ({
    ...rest,
  });

  const onChangeNewPortValue = async (index, value, id, isDate) => {
    let newAddPortsArray = [...emailFleetList];
    setLoader(true);
    const data = {
      id: id,
      value: value,
      isDate,
    };
    await actions
      .changeAutoVesselDetails(data)
      .then((res) => {
        if (isDate) {
          newAddPortsArray[index].nearestDate = { date: value };
        } else {
          newAddPortsArray[index].nearestport = value;
        }
        setEmailFleetList(newAddPortsArray);

        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        toastError();
      });
  };
  const onSaveAllVesselsFromAuto = () => {
    const output = emailFleetList?.filter((itm) =>
      selectedAutoFleet.find((item) => item._id === itm?._id)
    );
    if (!output?.length) {
      toastError("Please select vessel!");
      return;
    }
    if (!!checkForRequiredFromAuto(output))
      return toastError("Please fill required fields");
    const resulted = output?.map((item) => {
      return {
        ...removeExtraFieldFromAuto(item),
        fromAutoVesselId: item?._id,
        ...item?.nearestport,
        port: item?.nearestport?.name,
        dateOpen: moment(item?.nearestDate?.date).toISOString(),
        vesselId: item?.vesselId,
        vessel: JSON.stringify({
          ...removeExtraFieldFromAutoVessel(item.vesseldata),
          createdUser: { _id: item.vesseldata?.createdUser },
        }),
      };
    });
    setAddFleetModal(false);
    setLoader(true);
    actions
      .addMultiFleet(resulted)
      .then((res) => {
        getAllFleets();
        setLoader(false);
        setSelectedAutoFleet([]);
        // setAddFleetModal(false);
        toastSuccess("Vessel(s) added successfully");
        // setAddFleetsArray([{ ...initialAddFleet }]);
        onSubmitAutoSearch();
      })
      .catch((err) => {
        // setAddFleetModal(false);
        setLoader(false);
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  const onSaveAllVessels = () => {
    if (autoSwitch) return onSubmitAutoFleet();
    if (!!checkForRequired()) return toastError("Please fill required fields");
    let checkValidate = false;
    for (let i = 0; i < addFleetsArray?.length; i++) {
      if (!addFleetsArray[i]?.isValidate) {
        checkValidate = true;
      }
    }
    if (checkValidate) {
      return toastError("Please Validate Vessel's required fields");
    }
    const resulted = addFleetsArray.map((item) => {
      return {
        ...removeExtraField(item),
        dateOpen: moment(item.dateOpen).toISOString(),
        vesselId: item.selectedVessel._id,
        vessel: JSON.stringify(item.selectedVessel),
      };
    });
    setAddFleetModal(false);
    setLoader(true);
    actions
      .addMultiFleet(resulted)
      .then((res) => {
        saveGuideProgress("vessel", { created: true });
        getAllFleets();
        setLoader(false);
        setAddFleetModal(false);
        // Redirect to Vessel List tab only on success
        if (window.redirectToVesselListTab) window.redirectToVesselListTab();
        else setValue(0);
        toastSuccess("Vessel(s) added successfully");
        setAddFleetsArray([{ ...initialAddFleet }]);
        if (window.handleVesselTourAction) {
          window.handleVesselTourAction('vessel_added');
        }
      })
      .catch((err) => {
        setAddFleetModal(false);
        setLoader(false);
        toastError(err?.data?.message || "Something went wrong");
        if (window.handleVesselTourAction) {
          window.handleVesselTourAction('vessel_add_failed');
        }
      });
  };

  const onChangeAutoSwitch = (checked) => {
    setAutoSwitch(checked);
  };

  const updatedSinceLastOptions = () => {
    const arr = [];
    for (let i = 0; i < 30; i++) {
      arr.push({ label: String(i + 1), value: String(i + 1) });
    }
    return arr;
  };

  const onChangeAutoFilters = (name, value) => {
    setAutoFilters({ ...autoFilters, [name]: value });
  };

  const onSubmitAutoSearch = () => {
    const { updateSince, portRegion, vesselType, gear } = autoFilters || {};
    const modifiedFilters = {
      emailDateLower: moment()
        .subtract(Number(updateSince.value), "d")
        .startOf()
        .format("yyyy-MM-DD hh:mm"),
      emailDateUpper: moment().startOf().format("yyyy-MM-DD hh:mm"),
      dwtLower: Number(vesselType.value.split("_")[0]),
      dwtUpper: Number(vesselType.value.split("_")[1]),
      portRegion: portRegion.map((item) => item.value).join(","),
      orgId: getOrganizationId(),
      gear: gear.label,
    };
    setLoader(true);
    actions
      .getAutoEmailsVesselList(modifiedFilters)
      .then((res) => {
        if (Array.isArray(res)) setEmailFleetList(res);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const onSelectAllAutoFleet = ({ target: { checked } }) => {
    setAllSelected(checked);
    if (checked) {
      setSelectedAutoFleet(emailFleetList?.filter((itm) => !itm?.fleet_id));
    } else {
      setSelectedAutoFleet([]);
    }
  };

  const onAutoFleetListCheckBox = (selectedItem) => {
    let updatedSelectedAutoFleet = [...selectedAutoFleet];
    const fleetIndex = updatedSelectedAutoFleet.findIndex(
      (item) => item._id === selectedItem._id
    );
    if (fleetIndex > -1) {
      updatedSelectedAutoFleet.splice(fleetIndex, 1);
    } else {
      updatedSelectedAutoFleet.push(selectedItem);
    }
    setSelectedAutoFleet(updatedSelectedAutoFleet);
  };

  const onChangeDateOpening = (index, selectedItem, date) => {
    let updatedSelectedAutoFleet = [...selectedAutoFleet];
    let updatedEmailFleetList = [...emailFleetList];

    const fleetIndex = updatedSelectedAutoFleet.findIndex(
      (item) => item._id === selectedItem._id
    );
    if (fleetIndex > -1) {
      updatedSelectedAutoFleet[fleetIndex].dateOpen = date;
      setSelectedAutoFleet(updatedSelectedAutoFleet);
    }
    updatedEmailFleetList[index].dateOpen = date;
    setEmailFleetList(updatedEmailFleetList);
  };

  const onSubmitAutoFleet = () => {
    const findWithoutDate =
      selectedAutoFleet.find((item) => !item.dateOpen) || false;
    if (!!findWithoutDate)
      return toastError("Please add date to selected vessels");
    let promiseArray = selectedAutoFleet.map((item) =>
      actions.getVesselsWithId(item.vesselId)
    );
    setAddFleetModal(false);
    setLoader(true);
    Promise.all(promiseArray)
      .then((responseArray) => {
        let newAddFleetsArray = responseArray.map((vessel, index) => {
          const { vesselName = "", vesselDwt = "", id = "" } = vessel;
          const { dateOpen = "", portName = "" } =
            selectedAutoFleet[index] || {};
          return {
            vesselName,
            dwt: vesselDwt,
            port: portName,
            dateOpening: moment(dateOpen).toISOString(),
            tcEq: 0,
            gbb: 0,
            hirePerDay: 0,
            hireGbb: 0,
            frtCost: 0,
            profit: 0,
            loadability: 0,
            arrivalLoadPort: "",
            extra_Exp: "",
            bod: 0,
            constan: 0,
            remark: "",
            vesselId: id,
            vessel: JSON.stringify(vessel),
          };
        });
        actions
          .saveToFleet(newAddFleetsArray)
          .then((res) => {
            setLoader(false);
            toastSuccess("Vessel(s) added successfully");
          })
          .catch((err) => {
            setAddFleetModal(true);
            setLoader(false);
            toastError(err?.data?.message || "Something went wrong");
          });
      })
      .catch((err) => {
        setAddFleetModal(true);
        setLoader(false);
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  const onChangeVesselManager = (e, item) => {
    setLoader(true);
    const data = {
      checked: e.target.checked,
      vesselId: item?._id,
    };
    actions
      .updateVesselManagerData(data)
      .then(async (res) => {
        await getVesselManager();
        await getAllFleets(true);
        setLoader(false);
        if (data.checked) window.handleVesselTourAction?.("matrix_toggle");
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  const onUpdateMyVessel = (addFleetsArray) => {
    // if (!!checkForRequired() || !!checkForRequiredFromAuto(addFleetsArray)) return toastError("Please fill required fields");
    const resulted = addFleetsArray.map((item) => {
      return {
        ...removeExtraFieldFromAuto(item),
        ...item?.nearestport,
        port: item?.nearestport?.name,
        dateOpen: moment(item?.nearestDate?.date).toISOString(),
        vesselId: item?.vesselId,
        vessel: JSON.stringify({
          ...removeExtraFieldFromAutoVessel(item.vesseldata),
          createdUser: { _id: item.vesseldata?.createdUser },
        }),
      };
    });
    setLoader(true);
    actions
      .updateFleetData(resulted?.[0])
      .then((res) => {
        getAllFleets();
        setLoader(false);
        setOpen(false);
        toastSuccess("Vessel(s) Updated successfully");
        setAddFleetsArray([{ ...initialAddFleet }]);
      })
      .catch((err) => {
        setLoader(false);
        setOpen(false);
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  const onShareOrgSaveClick = async () => {
    const vesselName = shareLabel.trim();
    if (!vesselName) {
      setShareLabelError(true);
      return;
    }
    if (!getSingleVesselData || !organizationId) return;
    let { _id, ...data } = getSingleVesselData;
    data.access = "public";
    data.organizationId = organizationId;
    data.vesselName = vesselName;
    await actions.addFleet(data);

    setShareConfirm(false);
    setShareLabel("");
  };

  const onShareOrgClick = (item) => {
    setShareConfirm(!isShareConfirm);
    setSingleVesselData(item ? item : "");
    setShareLabel("");
    setShareLabelError(false);
  };

  const onLiveSharingChange = (fleet, liveShare) => {
    actions
      .updateLiveSharing({ fleetId: fleet?._id, liveShare })
      .then((res) => {
        getAllFleets();
        toastSuccess("Live Sharing Updated successfully");
      })
      .catch((err) => {
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  const onClickVesselVessel = (vessel) => {
    setSelectedVesssel(vessel);
    setSaveVesselVesselLabel("");
    setVesselVesselModal(true);
  };
  const onCloseVesselVessel = () => {
    setVesselVesselModal(false);
    setSelectedVesssel(null);
  };
  const onClickSaveVesselVessel = async () => {
    const newVesselVessel = {
      fleetList: [
        {
          ...selectedVesssel,
          vesselOut: {
            hireGbb: selectedVesssel?.hireGbb,
            hirePerDay: selectedVesssel?.hirePerDay,
            tcEq: selectedVesssel?.tcEq,
            port: selectedVesssel?.port,
            dateOpen: selectedVesssel?.dateOpen,
            DurationOut: selectedVesssel?.DurationOut,
            MinDuration: selectedVesssel?.MinDuration,
            MaxDuration: selectedVesssel?.MaxDuration,
            bnkDelhs: selectedVesssel?.bnkDelhs,
            bnkDells: selectedVesssel?.bnkDells,
            bnkDelmgo: selectedVesssel?.bnkDelmgo,
            bnkPriceDeliveryhs: selectedVesssel?.bnkPriceDeliveryhs,
            bnkPriceDeliveryls: selectedVesssel?.bnkPriceDeliveryls,
            bnkPriceDeliverymgo: selectedVesssel?.bnkPriceDeliverymgo,
            bnkPriceRedeliveryhs: selectedVesssel?.bnkPriceRedeliveryhs,
            bnkPriceRedeliveryls: selectedVesssel?.bnkPriceRedeliveryls,
            bnkPriceRedeliverymgo: selectedVesssel?.bnkPriceRedeliverymgo,
            bnkPriceSettlemenths: selectedVesssel?.bnkPriceSettlemenths,
            bnkPriceSettlementls: selectedVesssel?.bnkPriceSettlementls,
            bnkPriceSettlementmgo: selectedVesssel?.bnkPriceSettlementmgo,
            bnkQtyRedeliveryhs: selectedVesssel?.bnkQtyRedeliveryhs,
            bnkQtyRedeliveryls: selectedVesssel?.bnkQtyRedeliveryls,
            bnkQtyRedeliverymgo: selectedVesssel?.bnkQtyRedeliverymgo,
            bnkRedeliveryQtyTolerancehs:
              selectedVesssel?.bnkRedeliveryQtyTolerancehs,
            bnkRedeliveryQtyTolerancels:
              selectedVesssel?.bnkRedeliveryQtyTolerancels,
            bnkRedeliveryQtyTolerancemgo:
              selectedVesssel?.bnkRedeliveryQtyTolerancemgo,
            revenue: selectedVesssel?.revenue,
            miscRevenue: selectedVesssel?.miscRevenue,
          },
        },
      ],

      clientQuery: {
        qtyMode: "MOLOO",
        fuelPriceOverridden: false,
        cargoList: [
          {
            label: null,
            voyType: null,
            account: null,
            firstLoadPort: null,
            lastDischargePort: null,
            cargo: null,
            freight: null,
            tcEq: null,
            tcGbb: null,
            hire: "",
            hireGbb: null,
            profit: null,
            duration: null,
            freightMode: null,
            laycanBegin: null,
            laycanEnd: null,
            broker: null,
            lumpsumFreight: 0,
            stowFactor: 0,
            multiParcelMode: null,
            operation: "Commence",
            port: selectedVesssel?.port,
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: null,
            grade: null,
            adcom: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            factor: 1,
            seaTime: 0,
            portExp: 0,
            portStay: 0,
            extraDays: 0,
            supply: 0,
            sulfur: null,
            loadline: null,
            dwf: 0,
            draftRes: 0,
            waterDensity: 0,
            other: 0,
            dischargeQty: 0,
            speedNormal: 0,
            speedECA: 0,
            cargoTx: 0,
            cargoTxOverriddenValue: 0,
            arrivalTime: "N/A",
            departureTime: null,
            arrivalHsfo: 0,
            arrivalLsfo: 0,
            arrivalMgo: 0,
            departureHsfo: 0,
            departureLsfo: 0,
            departureMgo: 0,
            index: 0,
            lbmarker: "",
            lat: selectedVesssel?.lat || null,
            lng: selectedVesssel?.lng || null,
            country: null,
            portId: null,
            notes: null,
            cargoDetails: {
              distNormal: 0,
              distEca: 0,
              bnkrFactor: 0,
              speedReduce: 0,
              speedFactor: 0,
              arrivalBunkersHSFO: 0,
              arrivalBunkersLSFO: 0,
              arrivalBunkersMGO: 0,
              bunkerSuppliedHSFO: 0,
              bunkerSuppliedLSFO: 0,
              bunkerSuppliedMGO: 0,
              bunkerNonScrubberHSFO: 0,
              bunkerNonScrubberLSFO: 0,
              bunkerNonScrubberMGO: 0,
              bunkerScrubberHSFO: 0,
              bunkerScrubberLSFO: 0,
              bunkerScrubberMGO: 0,
              reserve: "Supply",
              paidBy: "Owner",
              fuelPriceType0Hsfo: 0,
              fuelPriceType0Lsfo: 0,
              fuelPriceType0Mgo: 0,
              fuelPriceType1Hsfo: 0,
              fuelPriceType1Lsfo: 0,
              fuelPriceType1Mgo: 0,
              fuelPriceType2Hsfo: 0,
              fuelPriceType2Lsfo: 0,
              fuelPriceType2Mgo: 0,
              fuelPriceType3Hsfo: 0,
              fuelPriceType3Lsfo: 0,
              fuelPriceType3Mgo: 0,
              fuelPriceType4Hsfo: 0,
              fuelPriceType4Lsfo: 0,
              fuelPriceType4Mgo: 0,
            },
            distanceOverridden: false,
            isExtra: false,
            version: 0,
            system: true,
          },
          {
            label: null,
            voyType: null,
            account: null,
            firstLoadPort: null,
            lastDischargePort: null,
            cargo: null,
            freight: "0",
            tcEq: null,
            tcGbb: null,
            hire: "",
            hireGbb: null,
            profit: null,
            duration: null,
            freightMode: null,
            laycanBegin: null,
            laycanEnd: null,
            broker: null,
            lumpsumFreight: 0,
            stowFactor: 0,
            multiParcelMode: null,
            operation: "Delivery-out",
            port: selectedVesssel?.port,
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: null,
            grade: null,
            adcom: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            factor: 1,
            seaTime: 0,
            portExp: 0,
            portStay: 0,
            extraDays: 0,
            supply: 0,
            sulfur: "Normal",
            loadline: "S-Summer",
            dwf: 0,
            draftRes: 0,
            waterDensity: 0,
            other: 0,
            dischargeQty: 0,
            speedNormal: 0,
            speedECA: 0,
            cargoTx: null,
            cargoTxOverriddenValue: 0,
            arrivalTime: "N/A",
            departureTime: null,
            arrivalHsfo: null,
            arrivalLsfo: null,
            arrivalMgo: null,
            departureHsfo: null,
            departureLsfo: null,
            departureMgo: null,
            index: 0,
            lbmarker: null,
            lat: selectedVesssel?.lat || null,
            lng: selectedVesssel?.lng || null,
            country: null,
            portId: null,
            notes: null,
            distanceOverridden: false,
            isExtra: true,
            version: 0,
            system: true,
            cargoDetails: {
              distNormal: 0,
              distEca: 0,
              bnkrFactor: 0,
              speedReduce: 0,
              speedFactor: 0,
              arrivalBunkersHSFO: 0,
              arrivalBunkersLSFO: 0,
              arrivalBunkersMGO: 0,
              bunkerSuppliedHSFO: 0,
              bunkerSuppliedLSFO: 0,
              bunkerSuppliedMGO: 0,
              bunkerNonScrubberHSFO: 0,
              bunkerNonScrubberLSFO: 0,
              bunkerNonScrubberMGO: 0,
              bunkerScrubberHSFO: 0,
              bunkerScrubberLSFO: 0,
              bunkerScrubberMGO: 0,
              reserve: "Supply",
              paidBy: "Owner",
              fuelPriceType0Hsfo: 0,
              fuelPriceType0Lsfo: 0,
              fuelPriceType0Mgo: 0,
              fuelPriceType1Hsfo: 0,
              fuelPriceType1Lsfo: 0,
              fuelPriceType1Mgo: 0,
              fuelPriceType2Hsfo: 0,
              fuelPriceType2Lsfo: 0,
              fuelPriceType2Mgo: 0,
              fuelPriceType3Hsfo: 0,
              fuelPriceType3Lsfo: 0,
              fuelPriceType3Mgo: 0,
              fuelPriceType4Hsfo: 0,
              fuelPriceType4Lsfo: 0,
              fuelPriceType4Mgo: 0,
            },
          },
          {
            label: null,
            voyType: null,
            account: null,
            firstLoadPort: null,
            lastDischargePort: null,
            cargo: null,
            freight: "0",
            tcEq: null,
            tcGbb: null,
            hire: "",
            hireGbb: null,
            profit: null,
            duration: null,
            freightMode: null,
            laycanBegin: null,
            laycanEnd: null,
            broker: null,
            lumpsumFreight: 0,
            stowFactor: 0,
            multiParcelMode: null,
            operation: "Redelivery-in",
            port: selectedVesssel?.port,
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: null,
            grade: null,
            adcom: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            factor: 1,
            seaTime: 0,
            portExp: 0,
            portStay: 0,
            extraDays: 0,
            supply: 0,
            sulfur: "Normal",
            loadline: "S-Summer",
            dwf: 0,
            draftRes: 0,
            waterDensity: 0,
            other: 0,
            dischargeQty: 0,
            speedNormal: 0,
            speedECA: 0,
            cargoTx: null,
            cargoTxOverriddenValue: 0,
            arrivalTime: "N/A",
            departureTime: null,
            arrivalHsfo: null,
            arrivalLsfo: null,
            arrivalMgo: null,
            departureHsfo: null,
            departureLsfo: null,
            departureMgo: null,
            index: 0,
            lbmarker: null,
            lat: selectedVesssel?.lat || null,
            lng: selectedVesssel?.lng || null,
            country: null,
            portId: null,
            notes: null,
            distanceOverridden: false,
            isExtra: true,
            version: 0,
            system: true,
            cargoDetails: {
              distNormal: 0,
              distEca: 0,
              bnkrFactor: 0,
              speedReduce: 0,
              speedFactor: 0,
              arrivalBunkersHSFO: 0,
              arrivalBunkersLSFO: 0,
              arrivalBunkersMGO: 0,
              bunkerSuppliedHSFO: 0,
              bunkerSuppliedLSFO: 0,
              bunkerSuppliedMGO: 0,
              bunkerNonScrubberHSFO: 0,
              bunkerNonScrubberLSFO: 0,
              bunkerNonScrubberMGO: 0,
              bunkerScrubberHSFO: 0,
              bunkerScrubberLSFO: 0,
              bunkerScrubberMGO: 0,
              reserve: "Supply",
              paidBy: "Owner",
              fuelPriceType0Hsfo: 0,
              fuelPriceType0Lsfo: 0,
              fuelPriceType0Mgo: 0,
              fuelPriceType1Hsfo: 0,
              fuelPriceType1Lsfo: 0,
              fuelPriceType1Mgo: 0,
              fuelPriceType2Hsfo: 0,
              fuelPriceType2Lsfo: 0,
              fuelPriceType2Mgo: 0,
              fuelPriceType3Hsfo: 0,
              fuelPriceType3Lsfo: 0,
              fuelPriceType3Mgo: 0,
              fuelPriceType4Hsfo: 0,
              fuelPriceType4Lsfo: 0,
              fuelPriceType4Mgo: 0,
            },
          },
        ],
      },
      autoSave: false,
      vesselVesselLabel: saveVesselVesselLabel,
    };
    setLoader(true);
    actions
      .createVesselVessel(newVesselVessel)
      .then((res) => {
        setLoader(false);
        onCloseVesselVessel();
        toastSuccess("vessel vessel calc. create successfully");
        // history.push(`/vessel-vessel/estimation/${res?.data?._id}`);
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message || "Something went wrong");
      });
  };

  // const boundingBoxesCoordinates = (selectedRegions) => {
  //   const formattedCoordinates = selectedRegions.flatMap(region =>
  //     Object.values(region.coordinates).map(coord => [coord])
  //   );
  //   return formattedCoordinates;
  // };

  // const fetchVesselDetailsUsingRegions = (selectedRegions) => {
  //   try {
  //     setSubLoader(true);

  //     if (socket) {
  //       socket.close();
  //     }
  //     const ws = new WebSocket(WS_URL);
  //     setSocket(ws);

  //     ws.onopen = () => {
  //       console.log("Connected to WebSocket server");
  //       const boundingBoxes = boundingBoxesCoordinates(selectedRegions) || [];
  //       ws.send(JSON.stringify({ type: "updateBoundingBoxes", boundingBoxes }));
  //     };

  //     ws.onmessage = (event) => {
  //       const data = event.data ? JSON.parse(event.data) : null;
  //       if (data?.MetaData) {
  //         const { MMSI, ShipName, time_utc, latitude, longitude } = data.MetaData;

  //         setReceivedMMSI((prevData) => {
  //           const existingIndex = prevData.findIndex((item) => item.MMSI === MMSI);
  //           let updatedData;

  //           if (existingIndex !== -1) {
  //             updatedData = prevData.map((item, index) =>
  //               index === existingIndex ? { MMSI, ShipName, time_utc, latitude, longitude } : item
  //             );
  //           } else {
  //             updatedData = [...prevData, { MMSI, ShipName, time_utc, latitude, longitude }];
  //           }

  //           if (updatedData.length >= 500) {
  //             ws.close();
  //           }

  //           return updatedData;
  //         });

  //         setSubLoader(false);
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.error("WebSocket error:", error);
  //       setSubLoader(false);
  //     };

  //     ws.onclose = () => {
  //       console.log("WebSocket connection closed");
  //       setSubLoader(false);
  //     };

  //     // Cleanup function to close WebSocket connection
  //     return () => {
  //       ws.close();
  //     };
  //   } catch (error) {
  //     console.error("Error fetching vessel details using regions:", error);
  //     setSubLoader(false);
  //   }
  // };

  // useEffect(() => {
  //   if (isDisplaySelectedRegionDataTable && selectedRegions.length > 0) {
  //     fetchVesselDetailsUsingRegions(selectedRegions);
  //   }
  // }, [isDisplaySelectedRegionDataTable]);
  const handleSelectedRegions = (refetch = false) => {
    !refetch && setIsDisplaySelectedRegionDataTable(true);
    const formattedCoordinates = selectedRegions.map((region) => {
      const coords = Object.values(region.coordinates);
      return [...coords, coords[0]];
    });
    let minDw, maxDw;

    if (selectedVesselType === "unknown" || selectedVesselType === "all") {
      minDw = selectedVesselType;
      maxDw = selectedVesselType;
    } else {
      minDw = Number(selectedVesselType.split("_")[0]);
      maxDw = Number(selectedVesselType.split("_")[1]);
    }

    const payload = {
      boundingBoxes: formattedCoordinates,
      minDw,
      maxDw,
    };
    getTrackedVessel(payload)
      .then((res) => {
        setReceivedMMSI(res.data);
        setFormatedCoordinates(formattedCoordinates);
      })
      .catch((err) => {
        console.error("Error fetching vessel details using regions:", err);
      });
  };

  const handleAisFilters = (data) => {
    const { search, startDate, endDate } = data;
    const payload = {
      boundingBoxes: formatedCoordinates,
      search,
      startDate,
      endDate,
    };
    getTrackedVessel(payload).then((res) => {
      setReceivedMMSI(res.data);
    });
  };

  const onDisplayRegionSelectionMap = () => {
    setIsDisplaySelectedRegionDataTable(false);

    // if (socket) {
    //   socket.close();
    // }
  };
  const onDisplayLiveLocationOfVessels = () => {
    setIsDisplayLiveLocationOfVessels(true);
  };

  const onChangeHandlerForNew = (e) => {
    let name = "";
    let value = "";
    let type = "text";
    let checked = false;

    if (e._isAMomentObject) {
      name = "dateOpen";
      value = e.toISOString();
    } else if (e.target) {
      ({ name = "", value = "", type = "checkbox", checked } = e.target);
    }

    let updatedVessel = { ...newVessel };

    if (type === "checkbox") {
      updatedVessel[name] = checked;
    } else {
      if (value && value.toString().split("")[0] === 0) return;
      updatedVessel[name] = value;
    }

    setNewVessel(updatedVessel);
  };

  const onCloseModal = () => {
    setVesselCreationMode(false);
    setNewVessel({ ...initialVesselState });
  };

  const addNewSplitHire = () => {
    let splitHire =
      (newVessel && newVessel.splitHire && JSON.parse(newVessel.splitHire)) ||
      [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    setNewVessel({
      ...newVessel,
      splitHire: JSON.stringify(splitHire),
    });
  };
  const onChangeBunkerPriceOverridden = (e) => {
    let { name = "", checked = "" } = e.target || {};
    let newUpdatedFleet = { ...newVessel };
    newUpdatedFleet[name] = checked;
    setNewVessel(newUpdatedFleet);
  };

  const onChangeSplitHire = (index, e, isDelete = false) => {
    let splitHire =
      (newVessel && newVessel.splitHire && JSON.parse(newVessel.splitHire)) ||
      [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedvessel = {
      ...newVessel,
      splitHire: JSON.stringify(splitHire),
    };
    setNewVessel(udpatedvessel);
  };

  const onChangePort = (name, value) => {
    setNewVessel((prevVessel) => ({
      ...prevVessel,
      port: value.name,
      selectedPort: value,
      lat: value.lat || "",
      lng: value.lng || "",
    }));
  };

  const onSubmitConfirm = () => {
    if (!newVessel.vesselName) return toastError("Vessel Name is required");

    setLoader(true);

    //
    const excludedFieldKeys = [
      "port",
      "lat",
      "lng",
      "bnkDelhs",
      "bnkDells",
      "bnkDelmgo",
      "bnkPriceDeliveryhs",
      "bnkPriceDeliveryls",
      "bnkPriceDeliverymgo",
      "bnkPriceRedeliveryhs",
      "bnkPriceRedeliveryls",
      "bnkPriceRedeliverymgo",
      "bnkPriceSettlemenths",
      "bnkPriceSettlementls",
      "bnkPriceSettlementmgo",
      "bnkQtyRedeliveryhs",
      "bnkQtyRedeliveryls",
      "bnkQtyRedeliverymgo",
      "bnkRedeliveryQtyTolerancehs",
      "bnkRedeliveryQtyTolerancels",
      "bnkRedeliveryQtyTolerancemgo",
      "bunkerPriceOverridden",
      "dateOpen",
      "gbb",
      "hirePerDay",
      "hireGbb",
      "remark",
      "constants",
      "extraExpense",
      "splitHire",
    ];

    const excludedFields = Object.fromEntries(
      excludedFieldKeys.map((key) => [key, newVessel[key]])
    );

    const { ...otherFields } = newVessel;

    const cleanedFields = Object.fromEntries(
      Object.entries(otherFields).filter(
        ([key]) => !excludedFieldKeys.includes(key)
      )
    );

    const vesselString = JSON.stringify(cleanedFields);

    const finalVesselData = {
      vesselName: newVessel.vesselName,
      dwt: newVessel.vesselDwt,
      dateOpen: newVessel.dateOpen,
      ...excludedFields,
      vessel: vesselString,
      superAdminApproval: "pending",
      port: newVessel.selectedPort?.portLabel || "",
      dateOpen: newVessel.dateOpen,
    };

    // The Vessel record only stores vessel specs; hire, port, date and bunker data belong to the fleet row.
    // The description lives in vesselExtraDetails on the Vessel record.
    const manualVesselData = {
      ...newVessel,
      vesselExtraDetails: { ...newVessel.vesselExtraDetails, vesselTextDescription: newVessel.vesselTextDescription },
    };
    const apiCall = vesselCreationMode === "manual"
      ? dashboardActions.createVessel(manualVesselData)
      : actions.addFleet(finalVesselData);

    apiCall
      .then((res) => {
        if (vesselCreationMode === "manual") {
          // Put the new vessel and its hire/bunker details into the Add Vessel table, ready for "Add to My Vessels".
          const fleetFields = Object.fromEntries(Object.entries(excludedFields).filter(([, v]) => v !== undefined));
          const row = {
            ...initialAddFleet,
            ...fleetFields,
            vesselName: newVessel.vesselName,
            selectedVessel: { ...initialAddFleet.selectedVessel, ...res?.data },
            selectedPort: { ...initialAddFleet.selectedPort, ...newVessel.selectedPort },
          };
          setAddFleetsArray((prev) => {
            const emptyIdx = prev.findIndex((r) => !r.vesselName);
            return emptyIdx >= 0 ? prev.map((r, i) => (i === emptyIdx ? row : r)) : [...prev, row];
          });
        }
        onCloseModal();
        setLoader(false);
        toastSuccess("Vessel Created Successfully");
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message);
      });
  };

  const handleAisVesselCreation = async (_id) => {
    actions
      .getVesselsWithId(_id)
      .then((res) => {
        setNewVessel(res.data);
        setVesselCreationMode("ais");
      })
      .catch((err) => {
        console.error("Error fetching vessel details:", err);
      });
  };

  const onExportVesselPdf = async (item, mode) => {
    setLoader(true);
    try {
      await exportVesselPdf(item, mode, prepareShare);
    } catch (err) {
      toastError(err?.data?.message || "Could not create the PDF");
    }
    setLoader(false);
  };

  const handleCreateVesselContract = (data) => {
    const { _id, ...rest } = data;
    setFormData(prev => ({
      ...prev,
      vesselId: _id,
      vesselDetails: data,
    }));

    setIsVesselContractFormOpen(true);
  }

  const handleCloseVesselContract = () => {
    setFormData(initialVesselContractFormData);
    setAttachments([]);
    setTextContract(null);
    setIsVesselContractFormOpen(false);
  }

  const handleVesselContractInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setTextContract(e.target.files[0]);
    }
  };

  const handleAttachmentUpload = (e) => {
    if (e.target.files.length > 0) {
      setAttachments([...attachments, ...Array.from(e.target.files)]);
    }
  };

  const removeAttachment = (index) => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };

  const handleVesselContractSubmit = (e) => {
    e.preventDefault();
    if (!formData.contractName) {
      toastError('Contract Name is Required')
      return
    }
    const newVesselVessel = {
      ...formData?.vesselDetails,
      vesselOut: {
        hireGbb: formData?.vesselDetails?.hireGbb,
        hirePerDay: formData?.vesselDetails?.hirePerDay,
        tcEq: formData?.vesselDetails?.tcEq,
        port: formData?.vesselDetails?.port,
        dateOpen: formData?.vesselDetails?.dateOpen,
        DurationOut: formData?.vesselDetails?.DurationOut,
        MinDuration: formData?.vesselDetails?.MinDuration,
        MaxDuration: formData?.vesselDetails?.MaxDuration,
        bnkDelhs: formData?.vesselDetails?.bnkDelhs,
        bnkDells: formData?.vesselDetails?.bnkDells,
        bnkDelmgo: formData?.vesselDetails?.bnkDelmgo,
        bnkPriceDeliveryhs: formData?.vesselDetails?.bnkPriceDeliveryhs,
        bnkPriceDeliveryls: formData?.vesselDetails?.bnkPriceDeliveryls,
        bnkPriceDeliverymgo: formData?.vesselDetails?.bnkPriceDeliverymgo,
        bnkPriceRedeliveryhs: formData?.vesselDetails?.bnkPriceRedeliveryhs,
        bnkPriceRedeliveryls: formData?.vesselDetails?.bnkPriceRedeliveryls,
        bnkPriceRedeliverymgo: formData?.vesselDetails?.bnkPriceRedeliverymgo,
        bnkPriceSettlemenths: formData?.vesselDetails?.bnkPriceSettlemenths,
        bnkPriceSettlementls: formData?.vesselDetails?.bnkPriceSettlementls,
        bnkPriceSettlementmgo: formData?.vesselDetails?.bnkPriceSettlementmgo,
        bnkQtyRedeliveryhs: formData?.vesselDetails?.bnkQtyRedeliveryhs,
        bnkQtyRedeliveryls: formData?.vesselDetails?.bnkQtyRedeliveryls,
        bnkQtyRedeliverymgo: formData?.vesselDetails?.bnkQtyRedeliverymgo,
        bnkRedeliveryQtyTolerancehs:
          formData?.vesselDetails?.bnkRedeliveryQtyTolerancehs,
        bnkRedeliveryQtyTolerancels:
          formData?.vesselDetails?.bnkRedeliveryQtyTolerancels,
        bnkRedeliveryQtyTolerancemgo:
          formData?.vesselDetails?.bnkRedeliveryQtyTolerancemgo,
        revenue: formData?.vesselDetails?.revenue,
        miscRevenue: formData?.vesselDetails?.miscRevenue,
      },
      clientQuery: {
        qtyMode: "MOLOO",
        fuelPriceOverridden: false,
        cargoList: [
          {
            _id: uuidv4(),
            label: null,
            voyType: null,
            account: null,
            firstLoadPort: null,
            lastDischargePort: null,
            cargo: null,
            freight: null,
            tcEq: null,
            tcGbb: null,
            hire: "",
            hireGbb: null,
            profit: null,
            duration: null,
            freightMode: null,
            laycanBegin: null,
            laycanEnd: null,
            broker: null,
            lumpsumFreight: 0,
            stowFactor: 0,
            multiParcelMode: null,
            operation: "Commence",
            port: formData?.vesselDetails?.port,
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: null,
            grade: null,
            adcom: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            factor: 1,
            seaTime: 0,
            portExp: 0,
            portStay: 0,
            extraDays: 0,
            supply: 0,
            sulfur: null,
            loadline: null,
            dwf: 0,
            draftRes: 0,
            waterDensity: 0,
            other: 0,
            dischargeQty: 0,
            speedNormal: 0,
            speedECA: 0,
            cargoTx: 0,
            cargoTxOverriddenValue: 0,
            arrivalTime: "N/A",
            departureTime: null,
            arrivalHsfo: 0,
            arrivalLsfo: 0,
            arrivalMgo: 0,
            departureHsfo: 0,
            departureLsfo: 0,
            departureMgo: 0,
            index: 0,
            lbmarker: "",
            lat: formData?.vesselDetails?.lat || null,
            lng: formData?.vesselDetails?.lng || null,
            country: null,
            portId: null,
            notes: null,
            cargoDetails: {
              distNormal: 0,
              distEca: 0,
              bnkrFactor: 0,
              speedReduce: 0,
              speedFactor: 0,
              arrivalBunkersHSFO: 0,
              arrivalBunkersLSFO: 0,
              arrivalBunkersMGO: 0,
              bunkerSuppliedHSFO: 0,
              bunkerSuppliedLSFO: 0,
              bunkerSuppliedMGO: 0,
              bunkerNonScrubberHSFO: 0,
              bunkerNonScrubberLSFO: 0,
              bunkerNonScrubberMGO: 0,
              bunkerScrubberHSFO: 0,
              bunkerScrubberLSFO: 0,
              bunkerScrubberMGO: 0,
              reserve: "Supply",
              paidBy: "Owner",
              fuelPriceType0Hsfo: 0,
              fuelPriceType0Lsfo: 0,
              fuelPriceType0Mgo: 0,
              fuelPriceType1Hsfo: 0,
              fuelPriceType1Lsfo: 0,
              fuelPriceType1Mgo: 0,
              fuelPriceType2Hsfo: 0,
              fuelPriceType2Lsfo: 0,
              fuelPriceType2Mgo: 0,
              fuelPriceType3Hsfo: 0,
              fuelPriceType3Lsfo: 0,
              fuelPriceType3Mgo: 0,
              fuelPriceType4Hsfo: 0,
              fuelPriceType4Lsfo: 0,
              fuelPriceType4Mgo: 0,
            },
            distanceOverridden: false,
            isExtra: false,
            version: 0,
            system: true,
          },
          {
            _id: uuidv4(),
            label: null,
            voyType: null,
            account: null,
            firstLoadPort: null,
            lastDischargePort: null,
            cargo: null,
            freight: "0",
            tcEq: null,
            tcGbb: null,
            hire: "",
            hireGbb: null,
            profit: null,
            duration: null,
            freightMode: null,
            laycanBegin: null,
            laycanEnd: null,
            broker: null,
            lumpsumFreight: 0,
            stowFactor: 0,
            multiParcelMode: null,
            operation: "Delivery-out",
            port: formData?.vesselDetails?.port,
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: null,
            grade: null,
            adcom: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            factor: 1,
            seaTime: 0,
            portExp: 0,
            portStay: 0,
            extraDays: 0,
            supply: 0,
            sulfur: "Normal",
            loadline: "S-Summer",
            dwf: 0,
            draftRes: 0,
            waterDensity: 0,
            other: 0,
            dischargeQty: 0,
            speedNormal: 0,
            speedECA: 0,
            cargoTx: null,
            cargoTxOverriddenValue: 0,
            arrivalTime: "N/A",
            departureTime: null,
            arrivalHsfo: null,
            arrivalLsfo: null,
            arrivalMgo: null,
            departureHsfo: null,
            departureLsfo: null,
            departureMgo: null,
            index: 0,
            lbmarker: null,
            lat: formData?.vesselDetails?.lat || null,
            lng: formData?.vesselDetails?.lng || null,
            country: null,
            portId: null,
            notes: null,
            distanceOverridden: false,
            isExtra: true,
            version: 0,
            system: true,
            cargoDetails: {
              distNormal: 0,
              distEca: 0,
              bnkrFactor: 0,
              speedReduce: 0,
              speedFactor: 0,
              arrivalBunkersHSFO: 0,
              arrivalBunkersLSFO: 0,
              arrivalBunkersMGO: 0,
              bunkerSuppliedHSFO: 0,
              bunkerSuppliedLSFO: 0,
              bunkerSuppliedMGO: 0,
              bunkerNonScrubberHSFO: 0,
              bunkerNonScrubberLSFO: 0,
              bunkerNonScrubberMGO: 0,
              bunkerScrubberHSFO: 0,
              bunkerScrubberLSFO: 0,
              bunkerScrubberMGO: 0,
              reserve: "Supply",
              paidBy: "Owner",
              fuelPriceType0Hsfo: 0,
              fuelPriceType0Lsfo: 0,
              fuelPriceType0Mgo: 0,
              fuelPriceType1Hsfo: 0,
              fuelPriceType1Lsfo: 0,
              fuelPriceType1Mgo: 0,
              fuelPriceType2Hsfo: 0,
              fuelPriceType2Lsfo: 0,
              fuelPriceType2Mgo: 0,
              fuelPriceType3Hsfo: 0,
              fuelPriceType3Lsfo: 0,
              fuelPriceType3Mgo: 0,
              fuelPriceType4Hsfo: 0,
              fuelPriceType4Lsfo: 0,
              fuelPriceType4Mgo: 0,
            },
          },
          {
            _id: uuidv4(),
            label: null,
            voyType: null,
            account: null,
            firstLoadPort: null,
            lastDischargePort: null,
            cargo: null,
            freight: "0",
            tcEq: null,
            tcGbb: null,
            hire: "",
            hireGbb: null,
            profit: null,
            duration: null,
            freightMode: null,
            laycanBegin: null,
            laycanEnd: null,
            broker: null,
            lumpsumFreight: 0,
            stowFactor: 0,
            multiParcelMode: null,
            operation: "Redelivery-in",
            port: formData?.vesselDetails?.port,
            cargoQty: 0,
            tolerance: 0,
            rate: 0,
            terms: "SHINC",
            turnTime: 0,
            pdaRemarks: null,
            grade: null,
            adcom: 0,
            brokerage: 0,
            ttlComm: 0,
            netFrt: 0,
            min: 0,
            max: 0,
            factor: 1,
            seaTime: 0,
            portExp: 0,
            portStay: 0,
            extraDays: 0,
            supply: 0,
            sulfur: "Normal",
            loadline: "S-Summer",
            dwf: 0,
            draftRes: 0,
            waterDensity: 0,
            other: 0,
            dischargeQty: 0,
            speedNormal: 0,
            speedECA: 0,
            cargoTx: null,
            cargoTxOverriddenValue: 0,
            arrivalTime: "N/A",
            departureTime: null,
            arrivalHsfo: null,
            arrivalLsfo: null,
            arrivalMgo: null,
            departureHsfo: null,
            departureLsfo: null,
            departureMgo: null,
            index: 0,
            lbmarker: null,
            lat: formData?.vesselDetails?.lat || null,
            lng: formData?.vesselDetails?.lng || null,
            country: null,
            portId: null,
            notes: null,
            distanceOverridden: false,
            isExtra: true,
            version: 0,
            system: true,
            cargoDetails: {
              distNormal: 0,
              distEca: 0,
              bnkrFactor: 0,
              speedReduce: 0,
              speedFactor: 0,
              arrivalBunkersHSFO: 0,
              arrivalBunkersLSFO: 0,
              arrivalBunkersMGO: 0,
              bunkerSuppliedHSFO: 0,
              bunkerSuppliedLSFO: 0,
              bunkerSuppliedMGO: 0,
              bunkerNonScrubberHSFO: 0,
              bunkerNonScrubberLSFO: 0,
              bunkerNonScrubberMGO: 0,
              bunkerScrubberHSFO: 0,
              bunkerScrubberLSFO: 0,
              bunkerScrubberMGO: 0,
              reserve: "Supply",
              paidBy: "Owner",
              fuelPriceType0Hsfo: 0,
              fuelPriceType0Lsfo: 0,
              fuelPriceType0Mgo: 0,
              fuelPriceType1Hsfo: 0,
              fuelPriceType1Lsfo: 0,
              fuelPriceType1Mgo: 0,
              fuelPriceType2Hsfo: 0,
              fuelPriceType2Lsfo: 0,
              fuelPriceType2Mgo: 0,
              fuelPriceType3Hsfo: 0,
              fuelPriceType3Lsfo: 0,
              fuelPriceType3Mgo: 0,
              fuelPriceType4Hsfo: 0,
              fuelPriceType4Lsfo: 0,
              fuelPriceType4Mgo: 0,
            },
          },
        ],
      },
      autoSave: false,
      vesselVesselLabel: saveVesselVesselLabel,
    };
    const formPayload = new FormData();

    if (textContract) {
      const fileType = textContract.type || 'application/octet-stream';
      const fileName = textContract.name || 'contract';

      const textBlob = new Blob([textContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append('files', textFile);
      formPayload.append('textContractMetadata', JSON.stringify({ fileType: 'textContract' }));
    }

    // Append attachments if available
    if (attachments?.length) {
      attachments.forEach(file => {
        formPayload.append('files', file);
      });
    }

    // Append form data
    formPayload.append('data', JSON.stringify({
      ...formData,
      vesselDetails: newVesselVessel,
      organizationId,
    }));

    // Submit and handle response
    createVesselContract(formPayload)
      .then((res) => {
        setIsVesselContractFormOpen(false);
        setFormData(initialVesselContractFormData);
        setAttachments([]);
        setTextContract(null);
        toastSuccess('Vessel Contract created successfully!');
      })
      .catch((error) => {
        toastError(error?.data?.message);
      });
  };

  const tab = [
    { key: 0, label: "Vessel List", tooltip: "Displays all vessels you have created" },
    { key: 6, label: "Add Vessel", tooltip: "Add a new vessel manually.", "data-spotlight": "add-vessel-tab" },
  ];

  const tabItems = [
    {
      key: 1,
      label: "Manual",
      tooltip: "Add a new vessel manually.",
    },
    {
      key: 2,
      label: "Auto",
      tooltip:
        "Add New Inquiry and Displays vessels related to your recent inquiry.",
      "data-spotlight": "auto-tab"
    },
    {
      key: 3,
      label: "Users",
      tooltip:
        "Shows vessels added by users in your organization. You can copy them to your fleet",
    },
    {
      key: 4,
      label: "AIS",
    },
    {
      key: 5,
      label: "Markets",
    },
  ];

  useEffect(() => {
    if (showExtraTabs && value === 0) {
      setShowExtraTabs(false);
      setExtraTabsValue(0);
    }
    if (value === 6) {
      // Only default to sub-tab 1 if the URL doesn't specify a sub-tab.
      // This prevents overriding the sub-tab when navigating from sidebar.
      const searchParams = new URLSearchParams(location.search);
      const subTabParam = searchParams.get("subTab");
      if (!subTabParam) {
        setExtraTabsValue(1);
      }
      setShowExtraTabs(true);
    }
  }, [value]);

  useEffect(() => {
    const hasAnyVerifiedRow = Array.isArray(addFleetsArray) && addFleetsArray.some((item) => item?.isValidate);

    if (hasAnyVerifiedRow && !hasTriggeredVerificationStepRef.current && window.handleVesselTourAction) {
      hasTriggeredVerificationStepRef.current = true;
      // Emit both modal-related actions to support all verify completion paths.
      // Depending on how user completes the modal, tour may be waiting for one or the other.
      window.handleVesselTourAction("modal_next_clicked");
      window.handleVesselTourAction("verification_complete");
    }

    if (!hasAnyVerifiedRow) {
      hasTriggeredVerificationStepRef.current = false;
    }
  }, [addFleetsArray]);

  return (
    <Grid container className="w-full">
      {shareDialog}
      <Grid item xs={12} className="mb-3">
        <Box
          display="flex"
          alignItems="center"
          width="100%"
          gap={2}
          className="flex-wrap"
        >
          <div className="flex items-center gap-2">
            <CustomTabs tabs={tab} active={value} onChange={(e, val) => {
              handleChange(e, val);
              if (val === 6 && window.handleVesselTourAction) {
                window.handleVesselTourAction('vessel_tab_open');
              }
            }} />
          </div>
          {
            showExtraTabs && (
              <div className="flex flex-col items-start md:items-center gap-1.5 w-full md:w-auto md:mx-auto mt-3 md:mt-0">
                <span style={{ fontSize: 12, fontWeight: 500, color: "#313C4C", whiteSpace: "nowrap" }}>
                  Add Vessel with
                </span>
                <CustomTabs tabs={tabItems} active={extraTabsValue} onChange={(e, val) => {
                  handleChangeExtraTabs(e, val);
                  if (val === 2 && window.handleVesselTourAction) {
                    window.handleVesselTourAction('auto_tab_open');
                  }
                }} />
              </div>
            )
          }
          {value === 1 && (
            <Box
              sx={{
                marginLeft: "auto", // This pushes the button to the right
              }}
            >
              <CustomButton
                variant="contained"
                color="primary"
                onClick={() => onClickAddFleet()}
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  padding: "10px 20px",
                }}
              >
                Create Vessel
              </CustomButton>
            </Box>
          )}
        </Box>
      </Grid>
      <div className="add-fleet-modal-container w-full">
        <TabPanel value={value} index={0} className="px-0">
          <div
            style={{
              background: "#fff",
              borderRadius: 0,
              border: "1px solid #cbd5e1",
              overflow: "hidden",
              minHeight: loader ? "300px" : "auto",
            }}
            className="shadow-sm"
          >
            {myFilters?.totalPages > myFilters?.limit && (
              <div
                style={{
                  borderBottom: "1px solid #f1f5f9",
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "1px",
                }}
              >
                <CustomPagination
                  onChangePagination={onChangeMyPagination}
                  filters={myFilters}
                  totalPage={myFilters?.totalPages}
                />
              </div>
            )}
            <div style={{ overflowX: "auto" }}>
              <table className="fit-cols-mobile" style={{ width: "100%", borderCollapse: "collapse", minWidth: 1150 }}>
                <thead>
                  <tr style={{ background: "#e2e8f0" }}>
                    <th style={{ ...thStyle, width: 95, textAlign: "center" }}>Add to Matrix</th>
                    <th style={{ ...thStyle, width: 36, textAlign: "center" }}>No.</th>
                    <th style={{ ...thStyle, width: "18%", cursor: "pointer" }} onClick={() => handleSortClick("vesselName")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Vessel Name
                        <div style={{ color: myFilters.sortBy === "vesselName" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "vesselName" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "vesselName" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "8%", cursor: "pointer" }} onClick={() => handleSortClick("dwt")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        DWT
                        <div style={{ color: myFilters.sortBy === "dwt" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "dwt" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "dwt" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "16%", cursor: "pointer" }} onClick={() => handleSortClick("port")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Port
                        <div style={{ color: myFilters.sortBy === "port" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "port" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "port" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "11%", cursor: "pointer" }} onClick={() => handleSortClick("dateOpen")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Date Opening
                        <div style={{ color: myFilters.sortBy === "dateOpen" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "dateOpen" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "dateOpen" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "10%", cursor: "pointer" }} onClick={() => handleSortClick("hirePerDay")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Hire Per Day
                        <div style={{ color: myFilters.sortBy === "hirePerDay" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "hirePerDay" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "hirePerDay" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "8%", cursor: "pointer" }} onClick={() => handleSortClick("hireGbb")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Hire GBB
                        <div style={{ color: myFilters.sortBy === "hireGbb" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "hireGbb" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "hireGbb" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "12%" }}>Remark</th>
                    <th style={{ ...thStyle, width: "10%", cursor: "pointer" }} onClick={() => handleSortClick("createdDate")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Created on
                        <div style={{ color: myFilters.sortBy === "createdDate" ? "#0f172a" : "#64748b", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "createdDate" && myFilters.sortDirection === "desc" ? <LuArrowDown size={13} /> : myFilters.sortBy === "createdDate" && myFilters.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: "10%" }}>Created By</th>
                    <th style={{ ...thStyle, width: 90, textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isInitialLoading && (!Array.isArray(fleets) || !fleets.length) ? (
                    <tr>
                      <td
                        colSpan={12}
                        style={{ textAlign: "center" }}
                      >
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          {fleets?.length > 0 && <CircularProgress />}
                        </Box>
                      </td>
                    </tr>
                  ) : Array.isArray(fleets) && fleets.length ? (
                    fleets.map((item, index) => {
                      const parsedVessel = (() => {
                        try {
                          return typeof item?.vessel === "string"
                            ? JSON.parse(item?.vessel || "{}")
                            : (item?.vessel || {});
                        } catch (e) {
                          return {};
                        }
                      })();
                      const vesselName = parsedVessel?.vesselName || item?.vesselName || "—";
                      const vesselDwt = item?.dwt || parsedVessel?.vesselDwt || parsedVessel?.dwt || parsedVessel?.DWT || 0;

                      return (
                        <tr
                          key={item._id || index}
                          onDoubleClick={() => { onClickEditVessel(item); }}
                          style={{
                            transition: "background 0.15s",
                            cursor: "pointer",
                            backgroundColor: index % 2 === 1 ? "#f8fafc" : "#ffffff",
                          }}
                          className="hover:bg-slate-100/90 transition-colors"
                        >
                          <td style={{ ...tdStyle, textAlign: "center" }}>
                            <CustomTooltip
                              position="top"
                              text="Toggle to include this vessel in your Matrix Calculator"
                            >
                              <Switch
                                data-spotlight="matrix-toggle"
                                className="!m-0 !inline-flex !align-middle [&_.MuiSwitch-switchBase]:!p-1" 
                                checked={!vesselManager?.vesselIds?.includes(item?._id)}
                                onChange={(e) => {
                                  onChangeVesselManager(e, item);

                                }}
                                color="primary"
                                size="small"
                              />
                            </CustomTooltip>
                          </td>

                          <td style={{ ...tdStyle, color: "#64748b", textAlign: "center" }}>
                            {(myFilters.offset - 1) * myFilters.limit + index + 1}
                          </td>
                          <td style={{ ...tdStyle, color: "#1e293b" }}>
                            {vesselName || "—"}
                          </td>
                          <td style={tdStyle}>
                            {vesselDwt ? Number(vesselDwt).toLocaleString() : 0}
                          </td>
                          <td style={tdStyle}>
                            {item.port || "—"}
                          </td>
                          <td style={tdStyle}>
                            {moment(item.dateOpen).format("DD/MMM/yyyy")}
                          </td>
                          <td style={tdStyle}>
                            {item.hirePerDay || "—"}
                          </td>
                          <td style={tdStyle}>
                            {item.hireGbb || 0}
                          </td>
                          <td style={tdStyle}>
                            <CustomTooltip text={item.remark || ""}>
                              <span className="block truncate max-w-[250px]">
                                {item.remark || "—"}
                              </span>
                            </CustomTooltip>
                          </td>
                          <td style={tdStyle}>
                            {item.createdDate ? moment(item.createdDate).format("DD/MMM/yyyy") : "—"}
                          </td>
                          <td style={tdStyle}>
                            {item?.createdUser
                              ? `${item.createdUser?.firstName} ${item.createdUser?.lastName}`
                              : "—"}
                          </td>

                          <td style={{ ...tdStyle, textAlign: "center" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                              <button
                                onClick={() => onClickEditVessel(item)}
                                style={iconBtnStyle}
                                title="Edit"
                                data-spotlight="view-vessel-details"
                                onMouseEnter={(e) => { e.currentTarget.style.color = "#1d4ed8"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.color = "#334155"; }}
                              >
                                <FiEdit2 size={17} />
                              </button>

                              <CustomTooltip
                                position="top"
                                text="Enable to share live updates of this vessel with your team"
                              >
                                <Switch
                                  checked={Boolean(item?.liveShare)}
                                  onChange={() => {
                                    onLiveSharingChange(item, !item?.liveShare);
                                    if (window.handleVesselTourAction) {
                                      window.handleVesselTourAction('live_share_toggle');
                                    }
                                  }}
                                  color="primary"
                                  size="small"
                                  className="!m-0 !inline-flex !align-middle [&_.MuiSwitch-switchBase]:!p-1" 
                                  data-spotlight="live-share-toggle"
                                />
                              </CustomTooltip>

                              <button
                                onClick={(e) => handleMenuOpen(e, item)}
                                style={iconBtnStyle}
                                title="More"
                                data-spotlight="vessel-more-actions"
                                onMouseEnter={(e) => { e.currentTarget.style.color = "#0f172a"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.color = "#334155"; }}
                              >
                                <MoreVert style={{ fontSize: 18 }} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : null}
                </tbody>
              </table>
              {!loader && hasFetchedFleets && !fleets?.length && (
                <div className="sticky left-0 w-full flex flex-col items-center justify-center gap-1.5 py-10 px-4 bg-white text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-100 border border-slate-200 text-slate-400">
                    <LuInbox size={24} />
                  </div>
                  <p className="m-0 text-[12px] font-medium text-slate-700">No Fleet Found.</p>
                  <p className="m-0 text-[11px] text-slate-500">Try a different search or date range, or add a vessel.</p>
                </div>
              )}
            </div>
            {myFilters?.totalPages > myFilters?.limit && (
              <div
                style={{
                  borderTop: "1px solid #f1f5f9",
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "1px",
                }}
              >
                <CustomPagination
                  onChangePagination={onChangeMyPagination}
                  filters={myFilters}
                  totalPage={myFilters?.totalPages}
                />
              </div>
            )}
          </div>
        </TabPanel>
        <Menu
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              borderRadius: 8,
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              border: "1px solid #e2e8f0",
              minWidth: 200,
              padding: 0,
            },
          }}
          MenuListProps={{ style: { padding: 0 } }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem
            onClick={() => {
              onShareOrgClick(selectedItem);
              handleMenuClose();
            }}
            style={{ ...menuItemStyle }}
          >
            <FiShare2 size={14} color="#000" />
            Copy Share With Team
          </MenuItem>
          <MenuItem
            onClick={() => {
              onClickVesselVessel(selectedItem);
              handleMenuClose();
            }}
            style={{ ...menuItemStyle }}
          >
            <FiLogIn size={14} color="#000" />
            Add To Vessel Estimation
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCreateVesselContract(selectedItem);
              handleMenuClose();
            }}
            style={{ ...menuItemStyle }}
          >
            <FiFileText size={14} color="#000" />
            Create Vessel Contract
          </MenuItem>
          <MenuItem
            onClick={() => {
              onExportVesselPdf(selectedItem, "download");
              handleMenuClose();
            }}
            style={{ ...menuItemStyle }}
          >
            <FiDownload size={14} color="#000" />
            Download PDF
          </MenuItem>
          <MenuItem
            onClick={() => {
              onExportVesselPdf(selectedItem, "share");
              handleMenuClose();
            }}
            style={{ ...menuItemStyle }}
          >
            <FiShare2 size={14} color="#000" />
            Share PDF
          </MenuItem>
          <Divider style={{ margin: 0, backgroundColor: "#f1f5f9" }} />
          <MenuItem
            onClick={() => {
              onClickDeleteSavedFleet(selectedItem._id);
              handleMenuClose();
            }}
            style={{ ...menuItemStyle, color: "#ef4444" }}
          >
            <FiTrash2 size={14} />
            Delete
          </MenuItem>
        </Menu>

        {
          showExtraTabs && (
            <>
              <TabPanel value={extraTabsValue} index={1} dir={theme.direction} style={{ padding: 0 }}>
                <div className="bg-neutrals9 p-2 sm:p-3 min-h-[calc(100vh-196px)] w-full rounded-md">
                  <AutoAddFleet
                    onAddFleetLine={onAddFleetLine}
                    addFleetsArray={addFleetsArray}
                    saveVesselListByIndex={saveVesselListByIndex}
                    onChangeNewFleetsValue={onChangeNewFleetsValue}
                    delayVesselSearch={delayVesselSearch}
                    vesselLoading={vesselLoading}
                    savePortListByIndex={savePortListByIndex}
                    delayPortSearch={delayPortSearch}
                    portLoading={portLoading}
                    onDeleteVesselLine={onDeleteVesselLine}
                    onSaveAllVessels={onSaveAllVessels}
                    setValidationVessel={setValidationVessel}
                    setValidationVesselIndex={setValidationVesselIndex}
                    setVesselCreationMode={setVesselCreationMode}
                    onCreateWithAI={() => {
                      setAiOpen(true);
                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value={extraTabsValue} index={2} dir={theme.direction} style={{ padding: 0 }}>
                <div className="bg-neutrals9 p-2 sm:p-3 min-h-[calc(100vh-196px)] w-full rounded-md">
                  <ManualAddFleet
                    loader={loader}
                    updatedSinceLastOptions={updatedSinceLastOptions}
                    autoFilters={autoFilters}
                    onChangeAutoFilters={onChangeAutoFilters}
                    onSubmitAutoSearch={onSubmitAutoSearch}
                    emailFleetList={emailFleetList}
                    selectedAutoFleet={selectedAutoFleet}
                    onChangeDateOpening={onChangeDateOpening}
                    onAutoFleetListCheckBox={onAutoFleetListCheckBox}
                    allSelected={allSelected}
                    addFleetRegionOptions={addFleetRegionOptions}
                    onSelectAllAutoFleet={onSelectAllAutoFleet}
                    setValidationVesselFromAuto={setValidationVesselFromAuto}
                    setValidationVesselFromAutoIndex={
                      setValidationVesselFromAutoIndex
                    }
                    savePortListByIndex={savePortListByIndex}
                    delayPortSearch={delayPortSearch}
                    portLoading={portLoading}
                    onChangeNewPortValue={onChangeNewPortValue}
                    onSaveAllVessels={onSaveAllVesselsFromAuto}
                  />
                </div>
              </TabPanel>
              <TabPanel value={extraTabsValue} index={3} dir={theme.direction} style={{ padding: 0 }}>
                <div className="bg-neutrals9 p-2 sm:p-3 min-h-[calc(100vh-196px)] w-full rounded-md">
                  <UserCopyFleet
                    loader={loader}
                    setLoader={setLoader}
                    // getInitalQueryAndFleetData={getInitalQueryAndFleetData}
                    onClickAddFleet={onClickAddFleet}
                    getAllFleets={getAllFleets}
                  />
                </div>
              </TabPanel>
              <TabPanel value={extraTabsValue} index={4} dir={theme.direction} style={{ padding: 0 }}>
                <div className="bg-neutrals9 p-2 sm:p-3 min-h-[calc(100vh-196px)] w-full rounded-md">
                  {!isDisplaySelectedRegionDataTable &&
                    !IsDisplayLiveLocationOfVessels && (
                      <AisMap
                        setSelectedVesselType={setSelectedVesselType}
                        selectedVesselType={selectedVesselType}
                        onSubmit={() => handleSelectedRegions(false)}
                        Isloading={subLoader}
                        setSelectedRegions={setSelectedRegions}
                        selectedRegions={selectedRegions}
                      />
                    )}
                  {isDisplaySelectedRegionDataTable &&
                    !IsDisplayLiveLocationOfVessels && (
                      <div className="w-full">
                        <div className="flex justify-between items-center mb-2 mt-1">
                          <button
                            type="button"
                            onClick={() => onDisplayRegionSelectionMap()}
                            className="h-[26px] px-3 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#0c2f50] rounded-none border border-[#313C4C] cursor-pointer transition-colors"
                          >
                            Go to Region Selection Map
                          </button>
                          <div>
                            <SearchBar
                              onDateRangeChange={handleDateRangeChange}
                              placeholder={"Search with Vessel Name or MMSI,..."}
                              setSearchValue={onSearchChange}
                              searchValue={filtersForAis.search}
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => onDisplayLiveLocationOfVessels()}
                            className="h-[26px] px-3 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#0c2f50] rounded-none border border-[#313C4C] cursor-pointer transition-colors"
                          >
                            See on Map
                          </button>
                        </div>
                        <TableContainer
                          component={Paper}
                          className="shadow-md rounded-lg"
                          style={{
                            overflow: "hidden",
                          }}
                        >
                          <Table className="universal-table" stickyHeader>
                            {/* Table Header */}
                            <TableHead>
                              <TableRow className="bg-gray-100">
                                <TableCell className="font-semibold sticky top-0 z-10 w-[20%] bg-gray-100">
                                  MMSI
                                </TableCell>
                                <TableCell className="font-semibold sticky top-0 z-10 w-[25%] bg-gray-100">
                                  Ship Name
                                </TableCell>
                                <TableCell className="font-semibold sticky top-0 z-10 w-[25%] bg-gray-100">
                                  Time
                                </TableCell>
                                <TableCell className="font-semibold sticky top-0 z-10 w-[12%] bg-gray-100">
                                  Latitude
                                </TableCell>
                                <TableCell className="font-semibold sticky top-0 z-10 w-[12%] bg-gray-100">
                                  Longitude
                                </TableCell>
                                <TableCell className="font-semibold sticky top-0 z-10 bg-gray-100 text-center">
                                  Actions
                                </TableCell>
                              </TableRow>
                            </TableHead>

                            {/* Table Body */}
                            <TableBody>
                              {subLoader ? (
                                <TableRow>
                                  <TableCell colSpan={6} align="center" className="!bg-white">
                                    <Box display="flex" justifyContent="center" alignItems="center" height="250px">
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : Array.isArray(receivedMMSI) && receivedMMSI.length > 0 ? (
                                receivedMMSI.slice((aisPage - 1) * 50, aisPage * 50).map((vessel, index) => (
                                  <TableRow
                                    key={vessel.MMSI || vessel.mmsi || index}
                                    className="cursor-pointer hover:bg-sky-50"
                                  >
                                    <TableCell className="!py-0 !px-1.5 text-[11px] leading-tight h-[20px]">{vessel.mmsi}</TableCell>
                                    <TableCell className="!py-0 !px-1.5 text-[11px] leading-tight h-[20px]">{vessel.name || "Unknown"}</TableCell>
                                    <TableCell className="!py-0 !px-1.5 text-[11px] leading-tight h-[20px]">
                                      {new Date(vessel.updatedAt).toLocaleString()}
                                    </TableCell>
                                    <TableCell className="!py-0 !px-1.5 text-[11px] leading-tight h-[20px]">
                                      {(vessel.lat && vessel.lat?.toFixed(2)) ||
                                        "Unknown"}
                                    </TableCell>
                                    <TableCell className="!py-0 !px-1.5 text-[11px] leading-tight h-[20px]">
                                      {(vessel.lng && vessel.lng?.toFixed(2)) ||
                                        "Unknown"}
                                    </TableCell>
                                    <TableCell className="!py-0 !px-1.5 text-[11px] leading-tight h-[20px] text-center">
                                      <Tooltip title="Create Vessel">
                                        <IconButton
                                          color="primary"
                                          size="small"
                                          className="!p-0"
                                          onClick={() =>
                                            handleAisVesselCreation(vessel.vesselId)
                                          }
                                        >
                                          <PlaylistAddCheckRoundedIcon
                                            className="validate-icon-vessel-manager"
                                            fontSize="small"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell
                                    align="center"
                                    colSpan={6}
                                    className="!bg-white text-slate-500 py-6 text-[11px]"
                                  >
                                    No Vessel Data Found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {Array.isArray(receivedMMSI) && receivedMMSI.length > 0 && (
                          <div className="flex justify-end mt-2">
                            <CustomPagination
                              filters={{
                                offset: aisPage,
                                limit: 50,
                                totalPages: Math.ceil(receivedMMSI.length / 50) || 1,
                              }}
                              totalPage={receivedMMSI.length}
                              onChangePagination={(type) => {
                                if (type === "inc") {
                                  setAisPage((prev) => Math.min(prev + 1, Math.ceil(receivedMMSI.length / 50)));
                                } else if (type === "dec") {
                                  setAisPage((prev) => Math.max(1, prev - 1));
                                }
                              }}
                              apiName="ais"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  {IsDisplayLiveLocationOfVessels && (
                    <div className="h-[65vh]">
                      <div className="flex justify-between">
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => setIsDisplayLiveLocationOfVessels(false)}
                          color="primary"
                          className="mb-5"
                        >
                          Go Back
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleSelectedRegions(true)}
                          color="primary"
                          className="mb-5"
                        >
                          Refresh
                        </Button>
                      </div>
                      <LiveVesselLocation vesselList={receivedMMSI} />
                    </div>
                  )}
                </div>
              </TabPanel>
              <TabPanel value={extraTabsValue} index={5} dir={theme.direction} style={{ padding: 0 }}>
                <div className="bg-neutrals9 p-2 sm:p-3 min-h-[calc(100vh-196px)] w-full rounded-md">
                  Coming Soon
                </div>
              </TabPanel>
            </>
          )
        }
      </div>

      <CustomShowModal
        open={onValidationVesselFromAuto}
        disableClose
        handleClose={() => setValidationVesselFromAuto(false)}
        maxWidth="md"
        title="Update Details"
      >
        <EditVesselOnFleetAddStep
          onSubmitVessel={() => setValidationVesselFromAuto(false)}
          setValidationVesselFromAuto={setValidationVesselFromAuto}
          setAddFleetsArray={setEmailFleetList}
          addFleetsArray={emailFleetList}
          onValidationVesselIndex={onValidationVesselFromAutoIndex}
          onClickAddFleet={onClickAddFleet}
          isFromCreateVessel={true}
        />
      </CustomShowModal>
      <CustomShowModal
        open={open}
        disableClose
        handleClose={() => setOpen(false)}
        maxWidth="md"
        title="Update Details"
      >
        <EditVesselOnFleetAddStep
          onSubmitVessel={onUpdateMyVessel}
          setValidationVessel={setValidationVessel}
          setAddFleetsArray={setAddFleetsArray}
          addFleetsArray={[singleResults]}
          onValidationVesselIndex={0}
          isFromCreateVessel={true}
        />
      </CustomShowModal>

      <CustomAddModal
        open={onValidationVessel}
        saveLabel="Update"
        saveSpotlight="verification-confirm-btn"
        handleClose={() => setValidationVessel(false)}
        maxWidth="md"
        title="Update Details"
        onSubmitConfirm={() => {
          if (editVesselRef.current?.onSubmitUpdateVessel) {
            editVesselRef.current.onSubmitUpdateVessel();
          }
        }}
      >
        <EditVesselOnFleetAdd
          ref={editVesselRef}
          setValidationVessel={setValidationVessel}
          setAddFleetsArray={setAddFleetsArray}
          addFleetsArray={addFleetsArray}
          onValidationVesselIndex={onValidationVesselIndex}
          onClickAddFleet={onClickAddFleet}
          isFromCreateVessel={true}
        />
      </CustomAddModal>
      <CustomShowModal
        open={addFleetModal}
        disableClose
        handleClose={onClickAddFleet}
        maxWidth="md"
        title="Create Vessel"
      >
        <SingleVessel
          onClickAddFleet={onClickAddFleet}
          isFromCreateVessel={true}
        />
        {/* <AddFleetModal
          //   calculatorData={calculatorData}
          //   setCalculatorData={setCalculatorData}
          addFleetsArray={addFleetsArray}
          setAddFleetsArray={setAddFleetsArray}
          //   onChangeNewFleetsValue={onChangeNewFleetsValue}
          setLoader={setLoader}
          setAddFleetModal={setAddFleetModal}
          //   sendCalculationRequest={sendCalculationRequest}
          //   getInitalQueryAndFleetData={getInitalQueryAndFleetData}
          onClickAddFleet={onClickAddFleet}
          getAllFleets={getAllFleets}
        /> */}
      </CustomShowModal>
      <CustomConfirmModal
        open={deleteModal}
        handleClose={() => setDeleteModal(false)}
        message="Are you sure you want to delete this fleet?"
        onSubmitConfirm={onDeleteFleet}
        type="warning"
        confirmText="DELETE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />
      <CustomAddModal
        open={isShareConfirm}
        handleClose={onShareOrgClick}
        onSubmitConfirm={onShareOrgSaveClick}
        maxWidth="xs"
        saveLabel="Share"
        title="Share with Team"
        contentPaddingClass="!px-4 !py-2"
      >
        <SaveCargoLabel
          value={shareLabel}
          onChange={(e) => {
            setShareLabel(e.target.value);
            setShareLabelError(false);
          }}
          placeholder="Enter vessel name"
          label="Vessel name"
          guidanceTitle="Share this vessel"
          guidance="Create a team copy of this vessel. Your team can find it in Vessel Manager → All Vessel."
          error={shareLabelError ? "Enter a vessel name to share." : ""}
        />
      </CustomAddModal>

      <CustomAddModal
        open={vesselVesselModal}
        handleClose={onCloseVesselVessel}
        onSubmitConfirm={onClickSaveVesselVessel}
        maxWidth="xs"
        saveLabel="Save"
        title="Save to Vessel Vessel Estimation"
      >
        <SaveCargoLabel
          value={saveVesselVesselLabel}
          onChange={(e) => setSaveVesselVesselLabel(e.target.value)}
          placeholder="Enter estimate name"
          label="Estimate name"
          guidanceTitle="What will be saved"
          guidance="Start a Vessel Vessel estimate with this vessel as Vessel Out. Find it in Vessel Vessel Estimation → My Vessel."
        />
      </CustomAddModal>
      <VesselAIModal
        aiOpen={aiOpen}
        setAiOpen={setAiOpen}
        onAiFill={(patch) => {
          setNewVessel((prev) => ({ ...prev, ...patch }));
          setAiOpen(false);
          setVesselCreationMode("manual");
        }}
      />
      <CustomAddModal
        open={!!vesselCreationMode}
        saveLabel={"Add"}
        title="Create New Vessel"
        maxWidth="md"
        handleClose={() => setVesselCreationMode(false)}
        onSubmitConfirm={onSubmitConfirm}
      >
        <AddNewVessel
          vessel={newVessel}
          onChangeHandler={onChangeHandlerForNew}
          addNewSplitHire={addNewSplitHire}
          onChangeBunkerPriceOverridden={onChangeBunkerPriceOverridden}
          onChangeSplitHire={onChangeSplitHire}
          delayPortSearch={delayNewVesselPortSearch}
          portLoading={newVesselPortLoading}
          onChangePort={onChangePort}
          savePortList={newVesselSavePortList}
        />
      </CustomAddModal>
      <CustomAddModal
        open={isVesselContractFormOpen}
        saveLabel={"Create"}
        title="Create Vessel Contract"
        maxWidth="lg"
        handleClose={handleCloseVesselContract}
        onSubmitConfirm={handleVesselContractSubmit}
      >
        <VesselContractForm
          formData={formData}
          setFormData={setFormData}
          textContract={textContract}
          attachments={attachments}
          handleChange={handleVesselContractInputChange}
          removeAttachment={removeAttachment}
          handleAttachmentUpload={handleAttachmentUpload}
          handleTextContractUpload={handleTextContractUpload}
        />
      </CustomAddModal>
    </Grid >
  );
}

export default MyVessel;
